<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddCompetence</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form name="form" #f="ngForm">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <!-- Competence Name -->
                <div class="col-2 af-form-group">
                  <label for="template-Add-CompetenceName" translate>lblName <strong class="mlt6 required"> *
                    </strong></label>
                  <div class="lbl-info">
                    <input type="text" id="template-Add-CompetenceName" name="CompetenceName" #CompetenceName="ngModel"
                      class="form-control" [(ngModel)]="AddCometenceViewModel.Name" 
                      maxlength="80" required>
                    <div *ngIf="CompetenceName.invalid && (CompetenceName.dirty || CompetenceName.touched)"
                      class="help-block text-danger">
                      <div *ngIf="CompetenceName.errors.required"><span translate>lblNameRequired</span></div>
                      <div *ngIf="CompetenceName.errors.pattern"><span translate>lblSpecialCharacterAreNotAllowed</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Code -->
                <div class="col-2 af-form-group">
                  <label for="template-Add-CompetenceCode" translate>lblCode</label>
                  <div class="lbl-info">
                    <input type="text" id="template-Add-CompetenceCode" name="code" #code="ngModel" class="form-control"
                      [(ngModel)]="AddCometenceViewModel.Code" maxlength="6">
                  </div>
                </div>

                <!-- Priority -->
                <div class="col-2 af-form-group">
                  <label for="template-Add-CompetencePriority" translate>lblPriority </label>
                  <div class="lbl-info">
                    <input type="text" id="template-Add-CompetencePriority" name="priority" #priority="ngModel"
                      class="form-control" [(ngModel)]="AddCometenceViewModel.Priority" maxlength="2" pattern="^[0-9]*$"
                     (keypress)="isDigit($event)">
                  </div>
                </div>

                <div class="col-2">
                  <div class="custom-control custom-checkbox mt-25">
                    <input class="custom-control-input" type="checkbox" [(ngModel)]="isSelectAllBrand" id="customCheck1"
                      (ngModelChange)="selectAllBrand()" [ngModelOptions]="{standalone: true}" />
                    <label class="custom-control-label" style="line-height: 25px;" for="customCheck1"
                      translate>lblSelectAllBrand</label>
                  </div>
                </div>

                <div class="w-100"></div>

                <!-- ComptenceBrandValue -->
                <div class="col-2 af-form-group" *ngFor="let brand of brandList; let i=index">
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="{{brand.brandCode}}" name="{{ brand.brandCode }}" 
                  [(ngModel)]="brand.value"
                      >
                  <label class="custom-control-label" for="{{brand.brandCode}}" translate>
                      
                      <span translate>{{brand.brandCode}}</span>
                  </label>
                </div>
              </div>
              </div>

                <div class="w-100"></div>

                <!-- Is Active -->
                <div class="col-3 af-form-group">
                  <label>&nbsp;</label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive"
                        [checked]="AddCometenceViewModel.IsActive"
                        (change)="onChangeIsActive(AddCometenceViewModel.IsActive)">
                      <label class="custom-control-label" for="isActive">
                        <span translate>lblActive</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary btn-lg mr-sm-2" (click)="AddCompetence()" [disabled]="!f.valid "
              translate aria-label="Center Align"><em class="fa fa-plus font16 align-top mr-2"></em> lblAdd
            </button>
            <a (click)="OnClose()"  type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>